<template>
  <ValidationObserver ref="form">
    <v-row>
      <v-col cols="3">
        <ValidationProvider :rules="`required|min_value:0|max_value:${deuda.importe_restante}`"
                            :name="$t('El cliente entrega').toLowerCase()"
                            v-slot="{ errors, classes }"
        >
          <div class="control" :class="classes">
            <v-text-field
                hide-details
                v-model="entrega_deuda.importe"
                :label="$t('El cliente entrega')"
                type="number"
                :outlined="true"
                :dense="true"
            ></v-text-field>
          </div>
          <span class="error--text">{{ errors[0] }}</span>
        </ValidationProvider>
      </v-col>

      <v-col cols="3">
        <ValidationProvider rules="required"
                            :name="$t('Forma pago').toLowerCase()"
                            v-slot="{ errors, classes }"
        >
          <div class="control" :class="classes">
            <v-select
                v-model="entrega_deuda.forma_pago"
                hide-details
                :label="$t('Forma pago')"
                :items="data_form.formas_pago"
                :no-data-text="$t('No hay datos')"
                dense
                outlined
            ></v-select>
          </div>
          <span class="error--text">{{ errors[0] }}</span>
        </ValidationProvider>
      </v-col>

      <v-col cols="3">
        <ValidationProvider rules="required"
                            :name="$t('Fecha').toLowerCase()"
                            v-slot="{ errors, classes }"
        >
          <div class="control" :class="classes">
            <DatePicker
                v-model="entrega_deuda.fecha"
                :title="$t('Fecha')"
                :outlined="true"
                :dense="true"
                :hide_details="true"
                :allow_future="false"
            />
          </div>
          <span class="error--text">{{ errors[0] }}</span>
        </ValidationProvider>
      </v-col>

      <v-col cols="3">
        <v-text-field
            v-model="entrega_deuda.descripcion"
            :label="$t('Descripción')"
            outlined
            dense
            persistent-hint
            :hint="$t('Introduce una descripción (opcional)')"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn @click="save()" :disabled="delay_pagar" small class="primary">
          <v-icon small>mdi-content-save</v-icon>
          {{ $t('Guardar') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-center">
        <v-btn @click="delete_deuda" small class="red">
          <v-icon color="white" small>mdi-close-octagon</v-icon>
          <span class="white--text pl-2 pr-2">{{ $t('Eliminar deuda') }}</span>
          <v-icon color="white" small>mdi-close-octagon</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <DialogCanjearTarjeta
        v-if="show_dialog_regalo"
        v-model="show_dialog_regalo"
        :cliente="{is_anonymous: true}"
        :total="entrega_deuda.importe"
        :show_specific_tab="1"
        @on_select_tarjeta_regalo="(tarjeta_regalo)=>this.save(tarjeta_regalo.tarjeta_regalo.id)"
    />
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CONSTANTS from "@/utils/constants";
export default {
  name: 'FormEntregaDeuda',

  props: {
    deuda: {
      type: Object,
      default: {}
    }
  },

  data: () => ({
    CONSTANTS,
    delay_pagar: false,
    show_dialog_regalo: false,
    entrega_deuda: {
      importe: 0,
      fecha: null,
      descripcion: ""
    },
    data_form: {
      formas_pago: []
    },

  }),

  methods: {
    async save(id_tarjeta = null){
      if (!!id_tarjeta) {
        this.show_dialog_regalo = false
      }
      if (this.delay_pagar) return

      const form_valid = await this.$refs.form.validate()
      if (form_valid) {
        try {
          this.delay_pagar = true

          if (this.entrega_deuda.forma_pago === CONSTANTS.FORMAS_PAGO.TARJETA_REGALO && !id_tarjeta) {
            this.show_dialog_regalo = true
            this.delay_pagar = false
            return
          }

          if (!!id_tarjeta) {
            this.entrega_deuda.tarjeta_regalo_pago_deuda = id_tarjeta
          }

          await this.$store.dispatch('cliente/entrega_deuda', {
            deuda: this.deuda,
            entrega_deuda: this.entrega_deuda
          })

          this.$snotify.success(
            this.$t("La acción se ha realizado correctamente"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )

          const imprimirTicket = await this.$fire({
            html: this.$t('¿Desea imprimir el ticket?'),
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: this.$t('Imprimir'),
            cancelButtonText: this.$t('No Imprimir'),
          })

          if (imprimirTicket.value === true) {
            const movimientos = await this.$store.dispatch('caja/get_movimientos_cliente_caja',
                { params: {'deuda_id': this.deuda.id, 'ordering': '-fecha'}})
            window.open(this.$router.resolve({name: 'print_abono_deuda', params: {id: movimientos.results[0].id}}).href, '_blank')
          }

          this.$emit('on_save')
        } catch (err) {
          this.$snotify.error(
            this.$t("Ha ocurrido un error"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      }

      const func = () => {
        this.delay_pagar = false
      }
      setTimeout(func,2000);
    },

    async delete_deuda(){
      const resp = await this.$confirm("", "", "question",{
        html: `
                <h4 style="color: #F44336">${this.$t('¿Estás segur@ que deseas eliminar la deuda?')}</h4>
                <p style="margin-top: 15px;">${this.$t('Esta acción es diferente a la cancelación de la deuda y NO SE PUEDE DESHACER.')}</p>
                <p style="margin-top: 15px;">${this.$t('La deuda será eliminada y NO QUEDARÁ NINGÚN REGISTRO en la caja de la cantidad que queda pendiente sobre esta deuda.')}</p>
              `,
        confirmButtonText: this.$t('Eliminar deuda'),
        confirmButtonColor: '#F44336'
      })

      if (resp) {
        await this.$store.dispatch('cliente/delete_deuda', this.deuda)
        this.$snotify.success(
          this.$t("La acción se ha realizado correctamente"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
        this.$emit('on_delete')
      }
    },

    async get_form() {
      try{
        this.data_form = await this.$store.dispatch('cliente/get_form_deuda')
      }catch (err) {}
    },
  },

  mounted() {
    let today = this.$moment()
    this.entrega_deuda.fecha = today.format("YYYY-MM-DD")

    this.entrega_deuda.importe = this.deuda.importe_restante

    this.get_form()
  },

  watch:{
    'deuda': {
      handler(deuda) {
        this.entrega_deuda.importe = deuda.importe_restante
      }
    }
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    DialogCanjearTarjeta: () => import('@/views/Ventas/components/DialogCanjearTarjeta'),
  }
}
</script>
